import { Text, View } from "@react-pdf/renderer";
import i18n from "../../i18n";
import { NumberFormatTextPDF } from "../NumberFormatText";
import { tableDataTableStyles } from "./DataTable";

export function DataTableAASHTODataRow({ item, index, tableInput, tableCalculated }) {
  let decimalSeparator = i18n.resolvedLanguage === "de-DE" ? "," : ".";
  let thousandSeparator = i18n.resolvedLanguage === "de-DE" ? "." : ",";
  return (
    <View style={tableDataTableStyles.row}>
      {/* Description */}
      <Text style={tableDataTableStyles.title}>{tableInput[index].description}</Text>
      {/* Widening */}
      <Text style={tableDataTableStyles.title}>
        <NumberFormatTextPDF
          value={tableInput[index].widening.current}
          decimalScale={2}
          prefix={"INF"}
          decimalSeparator={decimalSeparator}
          thousandSeparator={thousandSeparator}
        />
      </Text>
      {/* LayerTop */}
      <Text style={tableDataTableStyles.title}>
        <NumberFormatTextPDF
          value={tableInput[index].layerTop.current}
          decimalScale={2}
          decimalSeparator={decimalSeparator}
          thousandSeparator={thousandSeparator}
        />
      </Text>
      <Text style={tableDataTableStyles.title}>
        <NumberFormatTextPDF
          value={tableInput[index].layerBottom.current}
          decimalScale={2}
          decimalSeparator={decimalSeparator}
          thousandSeparator={thousandSeparator}
        />
      </Text>
      <Text style={tableDataTableStyles.title}>
        <NumberFormatTextPDF
          value={tableCalculated[index]?.inclinedLength?.current}
          decimalScale={2}
          decimalSeparator={decimalSeparator}
          thousandSeparator={thousandSeparator}
        />
      </Text>
      <Text style={tableDataTableStyles.title}>
        <NumberFormatTextPDF
          value={tableInput[index]?.skinFriction?.current}
          decimalScale={2}
          decimalSeparator={decimalSeparator}
          thousandSeparator={thousandSeparator}
        />
      </Text>
      <Text style={tableDataTableStyles.title}>
        <NumberFormatTextPDF
          value={Number(tableCalculated[index]?.loadTakenInLayer?.current)}
          decimalScale={2}
          decimalSeparator={decimalSeparator}
          thousandSeparator={thousandSeparator}
        />
      </Text>
    </View>
  );
}
